import styles from './StatusBadge.module.css';

interface StatusBadgeProps {
  /** Label teks status (wajib — status tidak pernah warna-only) */
  label: string;
  /** Nama ikon (SVG kustom) */
  icon: StatusIcon;
  /** Level status menentukan warna */
  level: 'bahaya' | 'waspada' | 'aman' | 'banjir';
}

export type StatusIcon = 'segitiga' | 'seru' | 'perisai' | 'gelombang';

export function StatusBadge({ label, icon, level }: StatusBadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[level]}`}>
      <StatusIconSvg icon={icon} />
      <span>{label}</span>
    </span>
  );
}

function StatusIconSvg({ icon }: { icon: StatusIcon }) {
  const common = {
    width: 14,
    height: 14,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    'aria-hidden': true,
  } as const;

  switch (icon) {
    case 'segitiga':
      return (
        <svg {...common}>
          <path d="M12 3 2 21h20L12 3Z" />
          <path d="M12 10v5" />
          <circle cx="12" cy="18" r="0.5" fill="currentColor" />
        </svg>
      );
    case 'seru':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="10" />
          <path d="M12 7v6" />
          <circle cx="12" cy="16" r="0.5" fill="currentColor" />
        </svg>
      );
    case 'perisai':
      return (
        <svg {...common}>
          <path d="M12 2 4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6l-8-4Z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    case 'gelombang':
      return (
        <svg {...common}>
          <path d="M2 8c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
          <path d="M2 14c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
          <path d="M2 20c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        </svg>
      );
  }
}
